export default "__VITE_ASSET__DLMPmQxn__"